import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import { i18n } from '@/langs'
import naive from 'naive-ui'
import { router } from './router'
import './assets/tailwind.css'

const app = createApp(App)
app.use(naive)
app.use(router)
app.use(createPinia())
app.use(i18n)
app.mount('#app')
